'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _byArrowKeys = require('./by-arrow-keys');

Object.defineProperty(exports, 'byArrowKeys', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_byArrowKeys).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var actOnFiltered = function actOnFiltered(actionFn) {
  return function (filter) {
    return function (rows) {
      return rows.filter(filter).map(actionFn);
    };
  };
};

var applyWhenPredicate = function applyWhenPredicate(actionFn) {
  return function (predicate) {
    return function (row) {
      return predicate(row) ? actionFn(row) : row;
    };
  };
};

var actOnMatching = function actOnMatching(actionFn) {
  return function (filter) {
    return function (rows) {
      return rows.map(applyWhenPredicate(actionFn)(filter));
    };
  };
};

var returnRow = function returnRow(row) {
  return row;
};

var setAttrTo = function setAttrTo(attr) {
  return function (val) {
    return function (row) {
      return _extends({}, row, _defineProperty({}, attr, val));
    };
  };
};

var setSelectedTo = setAttrTo('selected');

var toggleRow = function toggleRow(row) {
  var s = row.selected || false;
  return _extends({}, row, {
    selected: !s
  });
};

var selectAll = function selectAll(rows) {
  return rows.map(setSelectedTo(true));
};

var selectNone = function selectNone(rows) {
  return rows.map(setSelectedTo(false));
};

var selectRows = function selectRows(filter) {
  return function (rows) {
    return {
      rows: actOnMatching(setSelectedTo(true))(filter)(rows),
      selectedRows: actOnFiltered(returnRow)(filter)(rows)
    };
  };
};

var selectToggle = function selectToggle(filter) {
  return function (rows) {
    return actOnMatching(toggleRow)(filter)(rows);
  };
};

exports.all = selectAll;
exports.none = selectNone;
exports.rows = selectRows;
exports.toggle = selectToggle;